import { FC } from 'react'
import TabPanel from '../../../components/LibraryDetailsTabPanel'
import BenchmarkingTab from '../../benchmarking-tab'
import { DevicesTabs } from '../../../useLibraryDetailsData'
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'
import { CompetitorAnalysisData, DetailedComparisonData } from 'models'

interface BenchmarkingTabPanelProps {
  benchmarkingTabLoading: boolean
  competitorAnalysisData: CompetitorAnalysisData | null
  detailedComparisonData: DetailedComparisonData | null
}

export const BenchmarkingTabPanel: FC<BenchmarkingTabPanelProps> = ({
  competitorAnalysisData,
  detailedComparisonData
}) => {
  const { active, snowflakeManifest, tabValue } = useLibraryDetails()

  const tabIndex = active
    ? tabValue === DevicesTabs.Benchmarking
      ? snowflakeManifest
        ? 3
        : 2
      : 10
    : tabValue === DevicesTabs.Benchmarking
    ? 1
    : 10

  return (
    <TabPanel value={tabIndex} index={tabIndex === 10 ? 12 : active ? (snowflakeManifest ? 3 : 2) : 1}>
      <BenchmarkingTab
        competitorAnalysisData={competitorAnalysisData}
        detailedComparisonData={detailedComparisonData}
      />
    </TabPanel>
  )
}
